import React from 'react';
import { motion } from 'framer-motion';
import { CloudArrowUp, Brain, Lightning, Image as ImageIcon } from '@phosphor-icons/react';

const CONFIG = {
  cloud: { icon: CloudArrowUp, label: 'Reaching Private Cloud Compute…', color: 'text-sky-300' },
  thinking: { icon: Brain, label: 'Lindey is thinking deeply…', color: 'text-violet-300' },
  agent: { icon: Lightning, label: 'Agent at work — browsing, clicking, extracting…', color: 'text-lime-300' },
  image: { icon: ImageIcon, label: 'Painting your image, pixel by pixel…', color: 'text-orange-300' },
};

export default function ProcessingVisual({ variant = 'cloud' }) {
  const c = CONFIG[variant] || CONFIG.cloud;
  const Icon = c.icon;
  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
      className="flex items-center gap-3 mb-4" data-testid={`processing-visual-${variant}`}>
      <div className="pv-wrap">
        <span className="pv-ring" />
        <span className="pv-ring pv-ring-b" />
        <span className="pv-orbit"><span className="pv-dot" /></span>
        <span className="pv-orbit pv-orbit-2"><span className="pv-dot pv-dot-2" /></span>
        <Icon weight="fill" className={`w-4 h-4 ${c.color} relative z-10`} />
      </div>
      <p className="text-xs text-white/40 pv-label">{c.label}</p>
    </motion.div>
  );
}
